import { ele } from "cables-shared-client";
import web from "../index.js";
import api from "../api.js";

export default class PageChangelog
{
    constructor(targetElement)
    {
        const url = new URL(window.location.href);
        const limit = url.searchParams.get("l") || 3;
        const offset = url.searchParams.get("o");
        let pagination = targetElement.dataset.pagination;
        pagination = web.parseDustJson(pagination, {});

        web.tabs.initPagination(ele.byQuery(".changelogPagination"), pagination, limit, offset, (newLimit, newOffset) =>
        {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set("l", newLimit);
            searchParams.set("o", newOffset);
            window.location.search = searchParams.toString();
        });
    }

    deleteEntry(targetElement)
    {
        if (!targetElement) return;
        const ts = targetElement.dataset.ts;
        if (!ts) return;
        api.delete("admin/changelog/" + ts, {}, (res) =>
        {
            window.location.reload();
        }, (err) =>
        {
            targetElement.innerText = err.msg ? err.msg : err;
            console.log("ERROR DELETING", targetElement.dataset.ts, err);
        });
    }

}
